import { call, getContext, put, takeEvery } from "redux-saga/effects";
import { CONTEXT } from "@const/redux";

import { sendEmailFailure, sendEmailSuccess } from "./actions";
import { sendEmailActionTypes } from "./actionTypes";

const sendEmailAsync = ({ EmailsService, payload }) => {
  if (!EmailsService) {
    return;
  }

  return EmailsService.sendEmailToFam(payload);
};

function* sendEmail({ payload }) {
  try {
    const { EmailsService } = yield getContext(CONTEXT.SERVICES);
    yield call(sendEmailAsync, { EmailsService, payload });

    yield put(sendEmailSuccess(payload));
  } catch ({ error }) {
    yield put(sendEmailFailure(error));
  }
}

export function* watchSendsEmail() {
  yield takeEvery(sendEmailActionTypes.request, sendEmail);
}
